import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "text-center mb-3 text-red-lighten-1"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = {
  key: 0,
  class: "text-center mt-1"
}
const _hoisted_6 = { class: "text-body" }
const _hoisted_7 = {
  key: 2,
  class: "d-flex align-center justify-center"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "Загрузка обновления", -1)

import { Update, UpdateDownloadService } from '@prodcard/core'
import { onBeforeUnmount } from 'vue'
import { ref, Ref } from 'vue'
import { createCtx } from '../helpers'


export default /*#__PURE__*/_defineComponent({
  __name: 'VUpdateApply',
  props: {
    updateDownloadService: {}
  },
  setup(__props: any) {

const props = __props;


const update: Ref<Update | undefined> = ref()
const showUpdateDialog = ref(false)

const updateWatcher = props.updateDownloadService.updateAvailable.subscribe(updateInfo => {
  update.value = updateInfo
  if (updateInfo?.critical) {
    showUpdateDialog.value = true
  }
})

const applyUpdate = async () => {
  await props.updateDownloadService.apply(createCtx())
}

onBeforeUnmount(() => {
  props.updateDownloadService.updateAvailable.unsubscribe(updateWatcher)
})

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (update.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_btn, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showUpdateDialog.value = true))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Доступно обновление")
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_dialog, {
      modelValue: showUpdateDialog.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showUpdateDialog).value = $event)),
      "max-width": 500,
      persistent: update.value?.critical
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          class: "pa-5 bg-white",
          variant: "flat"
        }, {
          default: _withCtx(() => [
            (update.value?.critical)
              ? (_openBlock(), _createElementBlock("h2", _hoisted_2, " Для продолжения работы необходимо обновить приложение "))
              : _createCommentVNode("", true),
            (update.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("h2", _hoisted_4, "Доступна новая версия - " + _toDisplayString(update.value.version), 1),
                  (update.value.releasedAt)
                    ? (_openBlock(), _createElementBlock("h4", _hoisted_5, "от " + _toDisplayString(update.value.releasedAt), 1))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(update.value.changes, (change, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      _createElementVNode("p", _hoisted_6, "- " + _toDisplayString(change), 1)
                    ]))
                  }), 128)),
                  _createVNode(_component_v_card_actions, { class: "justify-end" }, {
                    default: _withCtx(() => [
                      (!update.value?.critical)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (showUpdateDialog.value = false))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Позже")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_btn, {
                        onClick: applyUpdate,
                        variant: 'elevated'
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Обновить")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_component_v_btn, {
                    loading: true,
                    variant: 'plain'
                  })
                ]))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "persistent"])
  ], 64))
}
}

})